import React from "react";

const PHRASES = [
  "Free Laundry for Displaced Families",
  "Restoring Dignity",
  "Supporting Hamilton",
  "No Cost, No Questions",
  "Powered by Volunteers",
  "Clean Clothes, Bright Futures",
];

export default function Marquee() {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="marquee-ribbon"
      className="bg-[#EBB04D] text-[#1C1917] border-y border-[#D4A03E] overflow-hidden"
    >
      <div className="marquee-track flex whitespace-nowrap py-3 md:py-4">
        {items.map((p, i) => (
          <span
            key={i}
            className="font-display font-bold uppercase tracking-[0.16em] text-sm md:text-base px-8 inline-flex items-center gap-8"
          >
            {p}
            <span className="text-[#D85C41]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
